import Splide from "@splidejs/splide";
import { AutoScroll } from "@splidejs/splide-extension-auto-scroll";

class KdvGallery {
	constructor() {
		this.sliders = document.querySelectorAll(".js-kdv-gallery");
		if (!this.sliders.length) return;
		this.init();
	}

	init = () => {
		this.sliders.forEach((el) => {
			let splide = new Splide(el, {
				type: "loop",
				drag: "free",
				focus: "center",
				perPage: 5,
				gap: 20,
				lazyLoad: true,
				pagination: false,
				arrows: false,
				arrowPath:
					"M4 .755l14.374 11.245-14.374 11.219.619.781 15.381-12-15.391-12-.609.755z",
				autoScroll: {
					speed: 0.7,
				},
				breakpoints: {
					1399: {
						perPage: 4,
					},
					1199: {
						perPage: 3,
					},
					767: {
						perPage: 2,
						gap: 15,
					},
					480: {
						perPage: 1,
						gap: 10,
					},
				},
			});
			splide.mount({ AutoScroll });
		});
	};
}

jQuery(() => {
	new KdvGallery();
});
